"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.DateCell = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _nicbaseTranslation = require("nicbase-translation");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var mapStateToProps = function mapStateToProps(state) {
  var timezone = state.user.timezone;
  return {
    timezone: timezone
  };
};

var DateCell = function DateCell(_ref) {
  var date = _ref.date,
      timezone = _ref.timezone;
  return /*#__PURE__*/_react["default"].createElement("div", null, date ? /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedDate, {
    value: date,
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "numeric",
    minute: "numeric",
    timeZone: timezone
  })) : null);
};

exports.DateCell = DateCell;
DateCell.propTypes = {
  date: _propTypes["default"].string.isRequired,
  timezone: _propTypes["default"].string.isRequired
};
var ConnectedDateCell = (0, _reactRedux.connect)(mapStateToProps)(DateCell);

var renderer = function renderer(_ref2) {
  var cellData = _ref2.cellData;
  return /*#__PURE__*/_react["default"].createElement(ConnectedDateCell, {
    date: cellData
  });
};

renderer.propTypes = {
  cellData: _propTypes["default"].string
};
renderer.defaultProps = {
  cellData: ''
};
var _default = renderer;
exports["default"] = _default;